import { render } from "./Fonctionnalites.vue?vue&type=template&id=4db652d4&ts=true"
import script from "./Fonctionnalites.vue?vue&type=script&lang=ts"
export * from "./Fonctionnalites.vue?vue&type=script&lang=ts"

import "./Fonctionnalites.vue?vue&type=style&index=0&id=4db652d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__